module.exports = __webpack_public_path__ + "img/homefurnishingdescribeLogo.438d87bf.png";